import React, {useState, Fragment, useEffect} from 'react';
import { Card, CardContent} from '@mui/material';
import { obtenerDepartamentosPersonalizado, obtenerMunicipiosPersonalizado, setearDatosAlStore } from 'store/actions/customAction';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import {useDispatch, useSelector} from 'react-redux';
import { DeleteOutlined, NavigateBefore, NavigateNext } from '@mui/icons-material';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import Formulario from 'components/formulario';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import Modal from 'components/Modales/ModalDeConfirmacion';
import TablaPersonalizada from 'components/TablaPersonalizada';
import { functions } from 'constantes';

let datosAValidar = [];

const Cobertura = ({activeStep, numberStep, handleClose, cobertura}) => {
    // console.log("cobertura", cobertura)
    const {datosGenerales} = useSelector((state) => state);
    const dispatch = useDispatch();
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
    const [listadoDeCoberturas, setListadoDeCoberturas] = useState(cobertura.listadoDeCoberturas),
    [mostrarEliminarElemento, setMostrarEliminarElemento] = useState(false),
    [datosDelElemento, setDatosDelElemento] = useState({});
    const [catalogoDepartamentos] = useState('catalogoDepartamentos');
    const [catalogoMunicipios] = useState('catalogoMunicipios');

    const [header] = useState([
        { title: 'Departamento', field: 'departamento.name', cellStyle:{ maxWidth: '80px'}},
        { title: 'Municipio', field: 'municipio.name', cellStyle:{ maxWidth: '80px' }},
        { title: 'Acción', field: 'accion',
        render: rowData=><div style={{minWidth: '100px'}}>
            {
                (<div>
                    <TooltipPersonalizado title="Eliminar cobertura del listado" handleFunction={()=> removerElemento(rowData)} icon={<DeleteOutlined />} color="red" marginTop={0} fontSize={30} />
                </div>)
            }
            </div>
        },
    ]);

    const removerElemento = (rowItem) => {
        setDatosDelElemento(rowItem)
        setMostrarEliminarElemento(true);
    }

    useEffect(() => {
        datosAValidar = listadoDeCoberturas;
    }, [listadoDeCoberturas])

    useEffect(() => {
        obtenerDepartamentos();
    }, [])

    const obtenerDepartamentos = async () => {
        setcargandoSolicitud(true);
        const copiaDeCampos = Object.assign({}, camposDelFormulario);

        if(datosGenerales.departamentos.length > 0) {
            if(datosGenerales.departamentos?.length === 22 ) datosGenerales.departamentos.unshift({id: 340, nombre: "TODOS"})
            copiaDeCampos.departamento.list = datosGenerales.departamentos?.map( ({id, nombre}) => ({id, name: nombre}) );
            setcargandoSolicitud(false);
            return setCamposDelFormulario(copiaDeCampos);
        }

        const dataCustomFetch = {
            controller: catalogoDepartamentos,
            validateIfDataExists: true,
            stateInStore : datosGenerales?.departamentos,
            dispatchAction:  nombreDeAcciones.OBTENER_DEPARTAMENTOS,
        }

        const respuesta = await dispatch(obtenerDepartamentosPersonalizado(dataCustomFetch));
        setcargandoSolicitud(false);

        if(respuesta?.error) setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

        let datos = respuesta?.data?.map( ({id, nombre}) => ({id , name: nombre}) )
        if(datos?.length > 0) datos.unshift({id: 340, name: "TODOS"})
        copiaDeCampos.departamento.list = datos;
        setCamposDelFormulario(copiaDeCampos);
    };

    const obtenerMunicipios =async ({target}) => {
        const newState = Object.assign({}, camposDelFormulario);

        if(!target.value) {
            newState.municipio.list = [];
            newState.municipio.value = null;
            return;
        };

        setcargandoSolicitud(true);

        const dataCustomFetch = {
            controller: catalogoMunicipios,
            stateInStore : datosGenerales?.catalogos?.municipios,
            dispatchAction: nombreDeAcciones.OBTENER_MUNICIPIOS,
            departamentoID: target?.value
        }

        ServiciosDelAPI[catalogoMunicipios].metodoDeBusqueda.clear();
        ServiciosDelAPI[catalogoMunicipios].metodoDeBusqueda.setOperator("and");

        if(target.value !== 340) ServiciosDelAPI[catalogoMunicipios].metodoDeBusqueda.addEquals("departamento.id", target?.value);

        const respuesta = await dispatch(obtenerMunicipiosPersonalizado(dataCustomFetch));
        setcargandoSolicitud(false);

        if(respuesta?.error) {
            newState.municipio.list = [];
            newState.municipio.value = null;
            setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta.error?.message || "No se pudieron obtener los municipios", mostrarRespuesta: true, });
        }

        if(target.value === 340) {
            dispatch(setearDatosAlStore({ dispatchAction : nombreDeAcciones.LIMPIAR_LOS_MUNICIPIOS, data: respuesta?.data}));
            const todosLosMunicipios = respuesta?.data?.map( ({departamento, nombre, id}) => ({ id: `${departamento.id}${id}`, departamento: {id: departamento.id, name: departamento.nombre}, municipio: {id, name: nombre} }))
            newState.municipio.disabled = true;
            return setListadoDeCoberturas(todosLosMunicipios)
        }
        newState.municipio.disabled = false;
        let datos = respuesta?.data?.map( ({id, nombre}) => ({id , name: nombre}) )
        if(datos?.length > 0) datos.unshift({id: 0, name: "TODOS"})
        newState.municipio.list = datos;
        newState.municipio.value = null;
        setCamposDelFormulario(newState);
    };

    const cancelarAccion = () => {
        dispatch(setearDatosAlStore({ dispatchAction : nombreDeAcciones.LIMPIAR_TODO_EL_REDUCER}));
        handleClose();
    };

    const siguientePaso = async (dataForm) => {

        if(datosAValidar.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'warning', mensajeDeAlerta: `DEBE DE INGRESAR AL MENOS UNA COBERTURA!.`, mostrarRespuesta: true, });

        dataForm.listadoDeCoberturas = datosAValidar
        const copiaDeCampos = Object.assign({}, camposDelFormulario)
        copiaDeCampos.departamento.value = null;
        copiaDeCampos.municipio.value = null;
        copiaDeCampos.municipio.list = [];
        setCamposDelFormulario(copiaDeCampos)

        await dispatch(setearDatosAlStore({
            dispatchAction : nombreDeAcciones.SETEAR_DATOS_COBERTURAS,
            data: {
                cobertura: dataForm,
                activeStep : activeStep + 1,
                numberStep : numberStep + 1
            }
        }));
    }

    const regresar = (dataForm) => {
        dataForm.listadoDeCoberturas = datosAValidar
        dispatch(setearDatosAlStore({
            dispatchAction : nombreDeAcciones.SETEAR_DATOS_COBERTURAS,
            data: {
                cobertura: dataForm,
                activeStep : activeStep - 1,
                numberStep : numberStep - 1
            }
        }));
    };

    const agregarCoberturaAlListado = () => {
        const {departamento, municipio} = camposDelFormulario;

        if(!departamento.value?.id || !municipio.value) return setDatosDeRespuesta({ tipoDeAlerta: 'warning', mensajeDeAlerta: `SELECCIONE EL DEPARTAMENTO Y MUNICIPIO.`, mostrarRespuesta: true, });
        if(departamento.value.id === 340) return setDatosDeRespuesta({ tipoDeAlerta: 'warning', mensajeDeAlerta: `SELECCIONE EL DEPARTAMENTO!.`, mostrarRespuesta: true, });

        if(municipio.value.id === 0) {

            municipio.list.splice(0, 1)
            let listadoDeCoberturasCopia = [...datosAValidar];
            municipio.list.forEach( (item) => listadoDeCoberturasCopia.unshift({ id: `${departamento.value.id}${item.id}`, departamento: departamento.value, municipio: item }))

            const listadoElementosDuplicados = functions.eliminarDuplicadosEnArreglo2(listadoDeCoberturasCopia, 'id');

            camposDelFormulario.municipio.value = null;
            camposDelFormulario.municipio.list.unshift({id: 0, name: "TODOS"})
            return setListadoDeCoberturas(listadoElementosDuplicados)
        }

        if(datosAValidar.length > 0 ) {

            const existeCobertura = datosAValidar.some((item) => Number(item.id) === Number(`${departamento.value.id}${municipio.value.id}`) )
            if(existeCobertura) return setDatosDeRespuesta({ tipoDeAlerta: 'warning', mensajeDeAlerta: `LA COBERTURA SELECCIONADA YA FUE AGREGADA AL LISTADO!.`, mostrarRespuesta: true, });
        }

        setListadoDeCoberturas( prevState => [ { id: `${departamento.value.id}${municipio.value.id}`, departamento: departamento.value, municipio: municipio.value}, ...prevState])
    };


    const [camposDelFormulario, setCamposDelFormulario] = useState({
        tituloCobertura:{
            idelement: "tituloCobertura", title:'Departamento y Municipio', position:"center", elementType:'titulo', showTitleForm: true,  name: "tituloCobertura", value: "", isError:false,
        },
        departamento: {
            idelement: "departamento", value: null , label: "Seleccione el departamento *", pattern:"", validators: ['required'],
            errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: obtenerMunicipios, width: '40%', marginTop: '10px'
        },
        municipio: {
            idelement: "municipio", value: null , label: "Seleccione el municipio *", pattern:"", validators: ['required'],
            errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: undefined, width: '40%', marginTop: '10px'
        },
        boton:{
            idelement: "boton", elementType:'boton', name: "boton", value: "", isError:false, icon: "add_circle", handleFunction: agregarCoberturaAlListado, title: "Agregar cobertura al listado", color: "#53C22B"
        },
        acciones: {
            idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
        },
    });

    const [listadoDeBotones]= React.useState({
        "regresar":{"label":"Regresar", "icon": <NavigateBefore />,"callback":regresar,"loading":false,"size":"medium",
        "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
        "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false, isCancel: true,
    },
        "siguientePaso":{"label":"Siguiente", "icon": <NavigateNext />, "callback":siguientePaso,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelar":{"label":"Cancelar", "icon": <NavigateNext />,"callback":cancelarAccion,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const accionEliminarElemento = async () => {
        const {id} = datosDelElemento;
        const newData = listadoDeCoberturas.filter((item) => item.id !== id)

        setListadoDeCoberturas(newData);
        setMostrarEliminarElemento(false);
    }

    const cerrarModalEliminarElemento = () => setMostrarEliminarElemento(false);

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => setDatosDeRespuesta({tipoDeAlerta,mensajeDeAlerta,mostrarRespuesta,});

    const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;

    return (
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>
            <Card>
                <CardContent>
                    <Formulario
                        elements={camposDelFormulario}
                        buttonList={listadoDeBotones}
                    />
                    <TablaPersonalizada
                        pageSize={10}
                        data={listadoDeCoberturas}
                        title={"Listado de cobertura"}
                        header={header}
                    />
                </CardContent>
            </Card>
            {mostrarEliminarElemento && (
                <Modal
                    title={`¿Está seguro de eliminar la cobertura?`} message={"No podrá revertir esta acción"}
                    open={mostrarEliminarElemento} closeModal={cerrarModalEliminarElemento} titleButton={"Sí, estoy seguro"}
                    actionAdd={accionEliminarElemento}
                />
            )}
        </Fragment>
    );
}

export default Cobertura;